import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'
import { useSearchParams } from 'react-router-dom'

import FormSteps from 'components/v2/FormSteps'
import { ENewVehicleV2Step } from 'features/Vehicles/types'

export const NewVehicleV2Steps = ({
  currentStep,
  isEdit
}: {
  currentStep: ENewVehicleV2Step
  isEdit?: boolean
}): ReactElement => {
  const [, setSearchParams] = useSearchParams()
  return (
    <FormSteps.Container>
      <FormSteps.Item>
        <FormSteps.StepNumber isActive={currentStep === ENewVehicleV2Step.DETAILS} stepNb={ENewVehicleV2Step.DETAILS} />
        <FormSteps.ItemLink
          isClickeable={isEdit && currentStep !== ENewVehicleV2Step.DETAILS}
          onClick={(): void =>
            setSearchParams({
              step: ENewVehicleV2Step.DETAILS.toString()
            })
          }
        >
          <FormSteps.StepLabel>
            <FormattedMessage id="vehiclesV2.formSteps.details" defaultMessage="Details" />
          </FormSteps.StepLabel>
        </FormSteps.ItemLink>
      </FormSteps.Item>
      <FormSteps.Item>
        <FormSteps.StepNumber
          isActive={currentStep === ENewVehicleV2Step.FEATURES}
          stepNb={ENewVehicleV2Step.FEATURES}
        />
        <FormSteps.ItemLink
          isClickeable={isEdit && currentStep !== ENewVehicleV2Step.FEATURES}
          onClick={(): void =>
            setSearchParams({
              step: ENewVehicleV2Step.FEATURES.toString()
            })
          }
        >
          <FormSteps.StepLabel>
            <FormattedMessage id="vehiclesV2.formSteps.features" defaultMessage="Features" />
          </FormSteps.StepLabel>
        </FormSteps.ItemLink>
      </FormSteps.Item>
      <FormSteps.Item>
        <FormSteps.StepNumber
          isActive={currentStep === ENewVehicleV2Step.INSURANCE}
          stepNb={ENewVehicleV2Step.INSURANCE}
        />
        <FormSteps.ItemLink
          isClickeable={isEdit && currentStep !== ENewVehicleV2Step.INSURANCE}
          onClick={(): void =>
            setSearchParams({
              step: ENewVehicleV2Step.INSURANCE.toString()
            })
          }
        >
          <FormSteps.StepLabel>
            <FormattedMessage id="vehiclesV2.formSteps.insurance" defaultMessage="Insurance" />
          </FormSteps.StepLabel>
        </FormSteps.ItemLink>
      </FormSteps.Item>
      <FormSteps.Item>
        <FormSteps.StepNumber
          isActive={currentStep === ENewVehicleV2Step.DOCUMENTS}
          stepNb={ENewVehicleV2Step.DOCUMENTS}
        />
        <FormSteps.ItemLink
          isClickeable={isEdit && currentStep !== ENewVehicleV2Step.DOCUMENTS}
          onClick={(): void =>
            setSearchParams({
              step: ENewVehicleV2Step.DOCUMENTS.toString()
            })
          }
        >
          <FormSteps.StepLabel>
            <FormattedMessage id="vehiclesV2.formSteps.documents" defaultMessage="Documents" />
          </FormSteps.StepLabel>
        </FormSteps.ItemLink>
      </FormSteps.Item>
    </FormSteps.Container>
  )
}
